import { render, staticRenderFns } from "./EditCouponGroupModal.vue?vue&type=template&id=4568cf77"
import script from "./EditCouponGroupModal.vue?vue&type=script&lang=js"
export * from "./EditCouponGroupModal.vue?vue&type=script&lang=js"
import style0 from "./EditCouponGroupModal.vue?vue&type=style&index=0&id=4568cf77&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports